module.exports = __webpack_public_path__ + "img/caret-down-square-fill.e98f3be6.svg";